import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUpdateDocumentStatus = createSelector(
  [(store: RootState) => store.documentUpdate.updateDocumentStatus],
  (signStatus) => signStatus
);
